<script setup lang="ts">

export interface PropsBtn {
    container?: SizeKeys;
}

const props = withDefaults(
    defineProps<PropsBtn>(),
    {
        container: 'base'
    }
);

const classMapping = {
    base: 'container',
    docs: 'container-docs'
} as const;

type ClassMapping = typeof classMapping;
type KeysOfUnion<T> = T extends object ? keyof T : never;
type MatchingKeys<Base, Condition> = KeysOfUnion<Base> extends infer Key
    ? Key extends Condition
        ? Key
        : never
    : never;

type SizeKeys = MatchingKeys<ClassMapping, `${string}`>;

const computedClassesContainer = computed(() => {
    return classMapping[props.container];
});

</script>

<template>
  <div :class="[computedClassesContainer]"
       v-bind="$attrs"
  >
    <slot></slot>
  </div>
</template>

<style scoped lang="scss">

.container {
  width: 100%;

  @include layout($breakpoint-xx-large, $spacing-800, $spacing-600);

  @include desktop-1200 {
    @include layout($breakpoint-x-large - 1, $spacing-300, $spacing-300);
  }

  @include mobile-576 {
    @include layout($breakpoint-medium - 1, $spacing-200, $spacing-200);
  }
}

.container-docs {
  $breakpoint-xx-docs: 1344px;

  display: flex;
  flex-direction: column;
  align-self: stretch;
  width: 100%;
  max-width: $breakpoint-xx-docs;
  margin: 0 auto;
  padding: 0 1rem;

  .column {
    padding: 24px;
  }

  @include desktop-1200 {
    @include layout($breakpoint-x-large - 1, $spacing-300, $spacing-300);
  }

  @include mobile-576 {
    @include layout($breakpoint-medium - 1, $spacing-200, $spacing-200);
  }
}

</style>
